export { default } from "./fastObjectShallowCompare.mjs";